//该方法用于判断是否进入手机端
export function isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag
}

/**
 * 获取静态资源完整路径
 * @param {string} path 资源路径
 * @returns {string} 完整的资源路径
 */
export function getStaticUrl(url) {
    if(!url) return ''
  return url.startsWith('http') ? url : `https://zzmjart-official-site.obs.cn-east-3.myhuaweicloud.com${url}`
}